import React, {Component} from 'react';
import {connect} from 'react-redux';
import {unstable_batchedUpdates as batchedUpdates} from 'react-dom';
import {Grid, Checkbox} from '@material-ui/core';
import {
    getSupplyCenterList,
    getInternalOrderScHostAddress,
    applyInternalOrderTransfer,
    getSkuKitListOfInternalOrder,
    getLotQuantityOfInternalOrder,
    getAllSCList,
    getInternalOrderDetail,
} from 'Actions/host';
import {openNotification} from 'Actions/notification';
import BasicButton from 'Components/common/BasicButton';
import BasicOnInput from 'Components/common/BasicOnInput';
import BasicInput from 'Components/common/BasicInput';
import SelectInput from 'Components/common/SelectInput';
import BasicTextArea from 'Components/common/BasicTextArea';
import Counter from 'Components/counter/Counter';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';
import {loadLanguage} from 'Utils/jwtUtil';
import Header from 'Components/common/Header';
import Anchor from 'Components/common/Anchor';
import {USER_ROLE} from 'Utils/constant';
import copy from 'copy-to-clipboard';

class AddTransferOrder extends Component {
    state = {
        sku: '',
        quantity: 1,
        lotNo: '',
        supplyCenterId: '',
        transferToSupplyCenterId: '',
        loading: false,
        SClist: [],
        SCToList: [],
        fromSupplyCenterId: 0,
        toSupplyCenterId: 0,
        skuList: [],
        skuNum: '',
        lotList: [],
        LotNum: '',
        consigneeList: [],
        consignee: '',
        telephone: '',
        currentAddress: '',
        trackingNumber: '',
        selectedValue: 0,
        internalOrdercomments: '',
        internalSkuItemModels: [
            {id: 1, inventoryId: '', sku: '', lot: '', kit: '', quantity: 1},
        ],
        addSkuNum: 1,
        hostInforObj: {},
        orderNumber: '',
    };

    componentDidMount() {
        this.props.getSupplyCenterList();
        this.props.getAllSCList({type: 1});

        if (this.getParams().orderId) {
            this.setInternalOrderData(this.params.orderId);
        }
    }

    getParams = () => {
        let search = this.props.location.search.substring(1);
        let arr = search.split('&');
        this.params = {};

        arr.forEach((item) => {
            let temp = item.split('=');

            this.params[temp[0]] = temp[1];
        });
        return this.params;
    };

    setInternalOrderData = (orderId) => {
        this.props.getInternalOrderDetail({orderId: orderId}).then((res) => {
            if (res && res.status === 'success' && res.data) {
                let internalOrderData = res.data;
                let currentFromSC = internalOrderData.fromScName;
                let currentFromId = internalOrderData.fromScId;
                let currentTransferToSC = internalOrderData.toScName;
                let currentTransferToId = internalOrderData.toScId;
                let currentInternalInternalSkuItemModels = [];

                if (internalOrderData.internalOrderProductModels.length > 0) {
                    currentInternalInternalSkuItemModels = JSON.parse(
                        JSON.stringify(
                            internalOrderData.internalOrderProductModels,
                        ),
                    );
                    currentInternalInternalSkuItemModels.map(
                        (itemModal, indexModal) =>
                            (itemModal.kitDisplay = itemModal.itemDisplay),
                    );
                }

                setTimeout(() => {
                    batchedUpdates(() => {
                        this.setState({
                            supplyCenterId: currentFromSC,
                            fromSupplyCenterId: currentFromId,
                            transferToSupplyCenterId: currentTransferToSC,
                            toSupplyCenterId: currentTransferToId,
                            consignee: internalOrderData.receiver,
                            telephone: internalOrderData.receiverTel,
                            currentAddress: internalOrderData.receiverAddress,
                            trackingNumber: internalOrderData.expressNumber,
                            internalOrdercomments: internalOrderData.remark,
                            internalSkuItemModels:
                                currentInternalInternalSkuItemModels,
                            addSkuNum:
                                currentInternalInternalSkuItemModels.length,
                            orderNumber: internalOrderData.orderNumber,
                        });
                    });
                }, 200);
            }
        });
    };

    handleChange = (name, value) => {
        this.setState({
            [name]: value,
        });

        let currentParams = this.getParams();
        if (currentParams.orderId) {
            if (typeof value !== 'string') {
                this.setState({
                    supplyCenterId: value.fullName,
                    fromSupplyCenterId: value.id,
                });
            }
        }

        if (name === 'supplyCenterId') {
            this.searchSC(value, this.props.supplyCenterlist, name);
        }
    };

    handleTransferToScChange = (name, value) => {
        this.setState({
            [name]: value,
        });

        const {supplyCenterAlllist} = this.props;
        if (typeof value == 'string') {
            let data = supplyCenterAlllist.filter((item) => {
                return item['fullName'].search(value) !== -1;
            });
            this.setState({
                SCToList: data,
            });
        } else {
            this.props
                .getInternalOrderScHostAddress({scId: value.id})
                .then((res) => {
                    if (res && res.status === 'success' && res.data) {
                        this.setState({
                            currentAddress: res.data.address,
                            hostInforObj: res.data,
                            consignee: '',
                            telephone: '',
                            toSupplyCenterId: value.id,
                        });
                    }
                });
        }
        if (name === 'transferToSupplyCenterId') {
            this.searchSC(value, supplyCenterAlllist, name);
        }
    };

    handleSelectChange = (name, value) => {
        let consigneeList = [];
        if (this.state.hostInforObj) {
            let hostInfor = JSON.parse(JSON.stringify(this.state.hostInforObj));
            consigneeList = this.formatHostInfoList(hostInfor.hostList);
        }

        if (typeof value == 'string') {
            let searchConsigneeList =
                consigneeList.length > 0
                    ? consigneeList.filter((item) => {
                          return item['fullName'].search(value) !== -1;
                      })
                    : [];
            this.setState({
                consigneeList: searchConsigneeList,
                [name]: value,
            });
        } else {
            this.setState({
                scId: value.id,
                consignee: value.fullName,
                telephone: value.mobile,
            });
        }
    };

    formatHostInfoList = (hostList) => {
        let consigneeList = [];
        typeof hostList != 'undefined' &&
            hostList.length > 0 &&
            hostList.map((hostItem, hostIndex) => {
                let obj = {
                    id: hostItem.id,
                    fullName: hostItem.name,
                    mobile: hostItem.mobile,
                };
                consigneeList.push(obj);
            });
        return consigneeList;
    };

    handleSearchSkuChange = (name, value, key) => {
        if (typeof value !== 'string') {
            let currentParams = this.getParams();
            if (currentParams.orderId) {
                let currentInternalSkuItemModels = JSON.parse(
                    JSON.stringify(this.state.internalSkuItemModels),
                );
                currentInternalSkuItemModels.map((skuModal, skuIndex) => {
                    if (key === skuModal.id) {
                        skuModal[name] = value.sku;
                        skuModal.kitDisplay = value.fullName;
                        skuModal.itemDisplay = value.fullName;
                        skuModal.inventoryId = value.inventoryId;
                        skuModal.kit = value.kit;
                        skuModal.lot = '';
                        skuModal['shippingCondition'] = '';
                        skuModal['specifications'] = '';
                        skuModal['storeCondition'] = '';
                    }
                });

                this.setState({
                    internalSkuItemModels: currentInternalSkuItemModels,
                });
                this.getLotQuantityList(this.state.fromSupplyCenterId, value);
            } else {
                let currentInternalSkuList = JSON.parse(
                    JSON.stringify(this.state.internalSkuItemModels),
                );
                currentInternalSkuList.map((skuModal, skuIndex) => {
                    if (key === skuModal.id) {
                        skuModal[name] = value.sku;
                        skuModal.kitDisplay = value.fullName;
                        skuModal.itemDisplay = value.fullName;
                        skuModal.inventoryId = value.inventoryId;
                        skuModal.kit = value.kit;
                        skuModal.lot = '';
                        skuModal['shippingCondition'] = '';
                        skuModal['specifications'] = '';
                        skuModal['storeCondition'] = '';
                    }
                });

                this.setState({
                    internalSkuItemModels: currentInternalSkuList,
                });
                const supplyCenterId = this.state.supplyCenterId;
                if (
                    supplyCenterId &&
                    typeof supplyCenterId.id !== 'undefined' &&
                    supplyCenterId.id
                ) {
                    this.getSkuKitList(supplyCenterId, value.id);
                    if (typeof value !== 'string') {
                        this.getLotQuantityList(supplyCenterId.id, value);
                    }
                }
            }
        } else {
            let internalSkuModal = this.state.internalSkuItemModels;
            internalSkuModal.length > 0 &&
                internalSkuModal.map((skuModal, skuIndex) => {
                    if (key === skuModal.id) {
                        skuModal[name] = value ? value : '';
                        skuModal.kitDisplay = value ? value.value : '';
                        skuModal.itemDisplay = value ? value.value : '';
                        if (!value) {
                            skuModal.sku = '';
                            skuModal.kit = '';
                        }
                    }
                });
            this.querySkuList(value);

            this.setState({
                internalSkuItemModels: internalSkuModal,
            });
        }
    };

    getSkuKitList = (transferToSupplyCenterId, id) => {
        if (transferToSupplyCenterId) {
            this.props
                .getSkuKitListOfInternalOrder({
                    fromScId: transferToSupplyCenterId.id,
                    sku: id,
                })
                .then((res) => {
                    if (res && res.status === 'success') {
                        let skuKitList = [];
                        res.data.length > 0 &&
                            res.data.map((item, index) => {
                                let skuKitObj = {
                                    id: ++index,
                                    fullName: item.kitDisplay,
                                    inventoryId: item.inventoryId,
                                    sku: item.sku,
                                    kit: item.kit,
                                };
                                skuKitList.push(skuKitObj);
                            });
                        this.setState({
                            skuList: skuKitList,
                        });
                    }
                });
        } else {
            this.props.openNotification(
                T('host_internal_order_current_supply_center_not_null'),
                'danger',
            );
        }
    };

    getLotQuantityList = (fromScId, skuObj) => {
        this.props
            .getLotQuantityOfInternalOrder({
                fromScId: fromScId,
                inventoryId: skuObj.inventoryId,
                sku: skuObj.sku,
            })
            .then((res) => {
                if (res && res.status === 'success') {
                    let lotQuantityList = [];
                    res.data.length > 0 &&
                        res.data.map((item, index) => {
                            let lotQuantityObj = {
                                id: item.id,
                                fullName: item.lot,
                                inventoryId: item.inventoryId,
                                sku: item.sku,
                                kit: item.kit,
                                quantity: item.quantity,
                                shippingCondition: item.shippingCondition,
                                specifications: item.specifications,
                                storeCondition: item.storeCondition,
                            };
                            lotQuantityList.push(lotQuantityObj);
                        });
                    this.setState({
                        lotList: lotQuantityList,
                    });
                }
            });
    };

    handleLotChange = (name, value, key) => {
        if (typeof value !== 'string') {
            let currentInternalSkuItemModels = JSON.parse(
                JSON.stringify(this.state.internalSkuItemModels),
            );
            currentInternalSkuItemModels.map((skuModal, skuIndex) => {
                if (key === skuModal.id) {
                    skuModal[name] = value.fullName;
                    skuModal['quantity'] = 1;
                    skuModal['shippingCondition'] = value.shippingCondition;
                    skuModal['specifications'] = value.specifications;
                    skuModal['storeCondition'] = value.storeCondition;
                }
            });

            this.setState({
                internalSkuItemModels: currentInternalSkuItemModels,
            });
        } else {
            let internalSkuModal = this.state.internalSkuItemModels;
            internalSkuModal.length > 0 &&
                internalSkuModal.map((skuModal, skuIndex) => {
                    if (key === skuModal.id) {
                        skuModal.lot = value;
                    }
                });
        }
    };

    searchSC = (value, scList, name) => {
        if (typeof value == 'string') {
            let data = scList.filter((item) => {
                return item['fullName'].search(value) !== -1;
            });
            if (name === 'supplyCenterId') {
                this.setState({
                    SClist: data,
                });
            } else {
                this.setState({
                    SCToList: data,
                });
            }
        }
    };

    focusInput = () => {
        this.setState({
            SClist: this.props.supplyCenterlist,
        });
    };

    focusTransferToInput = () => {
        this.setState({
            SCToList: this.props.supplyCenterAlllist,
        });
    };

    focusReceiverInput = () => {
        let consigneeList = [];
        if (this.state.hostInforObj) {
            let hostInfor = JSON.parse(JSON.stringify(this.state.hostInforObj));
            consigneeList = this.formatHostInfoList(hostInfor.hostList);
        }
        this.setState({
            consigneeList: consigneeList,
        });
    };

    querySkuList = (queryValue) => {
        const {fromSupplyCenterId, currentFromSC, supplyCenterId} = this.state;
        let currentParams = this.getParams();
        if (currentParams.orderId) {
            this.getSkuKitList(
                {id: fromSupplyCenterId, fullName: currentFromSC},
                queryValue,
            );
        } else {
            this.getSkuKitList(supplyCenterId, queryValue);
        }
    };

    focusSkuNumInput = () => {
        let queryValue = '';
        this.querySkuList(queryValue);
        this.setState({
            skuList: this.state.skuList,
        });
    };

    focusLotNumInput = (comsId) => {
        let {internalSkuItemModels, fromSupplyCenterId, supplyCenterId} =
            this.state;
        let currentSkuObj = {};
        internalSkuItemModels.length > 0 &&
            internalSkuItemModels.map((skuModal, skuIndex) => {
                if (comsId === skuModal.id) {
                    currentSkuObj = skuModal;
                }
            });
        if (this.getParams().orderId) {
            this.getLotQuantityList(fromSupplyCenterId, currentSkuObj);
        } else {
            this.getLotQuantityList(supplyCenterId.id, currentSkuObj);
        }
    };

    handleTextArea = (name, value) => {
        this.setState({internalOrdercomments: value});
    };

    handleOnTelInput = (name, value) => {
        this.setState({telephone: value});
    };

    handleOnInput = (name, value) => {
        this.setState({currentAddress: value});
    };

    handleTrackingNumberInput = (name, value) => {
        this.setState({trackingNumber: value});
    };

    handleChangeRadio = (event) => {
        let value = event.target.value ? parseInt(event.target.value) : '';
        let isCheckedFlag = event.target.checked;
        this.setState({
            selectedValue: isCheckedFlag ? value : 0,
        });
    };

    changeNum = (value, currentIndex) => {
        let currentInternalSkuItemModels = JSON.parse(
            JSON.stringify(this.state.internalSkuItemModels),
        );
        currentInternalSkuItemModels.map((skuModal, skuIndex) => {
            if (currentIndex === skuModal.id) {
                skuModal.quantity = value;
            }
        });

        this.setState({
            internalSkuItemModels: currentInternalSkuItemModels,
        });
    };

    addInternalOrderSkuModal = () => {
        let {internalSkuItemModels, addSkuNum} = this.state;
        internalSkuItemModels.push({
            id: addSkuNum + 1,
            inventoryId: '',
            sku: '',
            lot: '',
            kit: '',
            quantity: 1,
            shippingCondition: '',
            storeCondition: '',
            specifications: '',
        });

        this.setState({
            internalSkuItemModels: internalSkuItemModels,
            addSkuNum: ++addSkuNum,
        });
    };

    submitSave = () => {
        this.setState({loading: true});

        const {localData} = this.props;
        const {
            supplyCenterId,
            transferToSupplyCenterId,
            fromSupplyCenterId,
            toSupplyCenterId,
            consignee,
            telephone,
            currentAddress,
            selectedValue,
            trackingNumber,
            internalOrdercomments,
            internalSkuItemModels,
        } = this.state;
        let currentParams = this.getParams();
        if (!supplyCenterId) {
            this.props.openNotification(
                T('host_internal_order_current_supply_center_not_null'),
                'danger',
            );
        } else if (!transferToSupplyCenterId) {
            this.props.openNotification(
                T('host_internal_order_transfer_to_not_null'),
                'danger',
            );
        } else if (
            typeof supplyCenterId !== 'string' &&
            typeof transferToSupplyCenterId !== 'string' &&
            supplyCenterId.id === transferToSupplyCenterId.id
        ) {
            this.props.openNotification(
                T('host_internal_order_current_sp_not_equals_transfer_to_sp'),
                'danger',
            );
        } else if (
            currentParams.orderId &&
            fromSupplyCenterId !== 0 &&
            fromSupplyCenterId === toSupplyCenterId
        ) {
            this.props.openNotification(
                T('host_internal_order_current_sp_not_equals_transfer_to_sp'),
                'danger',
            );
        } else if (!consignee) {
            this.props.openNotification(
                T('host_internal_order_consignee_not_null'),
                'danger',
            );
        } else if (!telephone) {
            this.props.openNotification(
                T('host_internal_order_telephone_not_null'),
                'danger',
            );
        } else if (!currentAddress) {
            this.props.openNotification(
                T('host_internal_order_shipping_address_not_null'),
                'danger',
            );
        } else if (selectedValue === 1 && !internalOrdercomments.trim()) {
            this.props.openNotification(
                T('pleaseEnter') + T('shippment_remark'),
                'danger',
            );
        } else if (selectedValue === 2 && !trackingNumber.trim()) {
            this.props.openNotification(
                T('pleaseEnter') + T('shippment_details_shipment_number'),
                'danger',
            );
        } else {
            const params = {};
            let currentParams = this.getParams();
            if (currentParams.orderId) {
                params.fromScId = this.getCurrentScId(
                    fromSupplyCenterId,
                    supplyCenterId,
                );
                params.toScId = this.getCurrentScId(
                    toSupplyCenterId,
                    transferToSupplyCenterId,
                );
            } else {
                params.fromScId =
                    this.state.supplyCenterId && this.state.supplyCenterId.id;
                params.toScId =
                    this.state.transferToSupplyCenterId &&
                    this.state.transferToSupplyCenterId.id;
            }
            params.receiver = consignee;
            params.receiverTel = telephone;
            params.receiverAddress = currentAddress;
            params.expressType =
                selectedValue === 1
                    ? 'SELF'
                    : selectedValue === 2
                    ? 'EXPRESS'
                    : '';
            params.remark = internalOrdercomments;
            params.expressNumber = trackingNumber;
            params.internalSkuItemModels = internalSkuItemModels;
            if (currentParams.orderId) {
                params.orderId = currentParams.orderId;
            }
            this.props
                .applyInternalOrderTransfer(params)
                .then((res) => {
                    if (res && res.data) {
                        this.setState({loading: false});
                        this.props.history.push('/internalTransferOrderList');
                        this.props.openNotification(
                            T('host_internal_order_create_success') + res.data,
                            'success',
                        );
                    }
                })
                .catch((res) => {
                    if (res && res.message) {
                        if (
                            res.message.indexOf(
                                'shortage of available stock',
                            ) !== -1 ||
                            res.message.indexOf('shortage of on hold stock') !==
                                -1
                        ) {
                            this.props.openNotification(
                                T(
                                    'host_internal_order_create_number_less_than_current_inventory',
                                ),
                                'danger',
                            );
                        } else if (
                            res.message === 'sku or kit should not be empty!'
                        ) {
                            if (localData.roleType === USER_ROLE.ADMIN) {
                                this.props.openNotification(
                                    T('host_internal_order_sku_not_null'),
                                    'danger',
                                );
                            } else {
                                this.props.openNotification(
                                    T(
                                        'host_internal_order_sku_or_kit_not_null',
                                    ),
                                    'danger',
                                );
                            }
                        } else {
                            let messageArry = res.message.split(',');
                            if (
                                messageArry.length > 0 &&
                                messageArry[2] &&
                                messageArry[3]
                            ) {
                                let skuMessageArry = messageArry[2].split(':');
                                if (
                                    skuMessageArry.length > 0 &&
                                    skuMessageArry[0].trim() === 'sku' &&
                                    skuMessageArry[1]
                                ) {
                                    if (
                                        messageArry[0] === 'shortage of stock'
                                    ) {
                                        this.props.openNotification(
                                            T('host_internal_order_sku_colon') +
                                                skuMessageArry[1] +
                                                T(
                                                    'host_internal_order_stock_shortage',
                                                ),
                                            'success',
                                        );
                                    } else {
                                        this.props.openNotification(
                                            T('host_internal_order_sku_colon') +
                                                skuMessageArry[1] +
                                                T(
                                                    'host_internal_order_lot_incorrect',
                                                ),
                                            'success',
                                        );
                                    }
                                }
                            } else if (res.status === 'lot_invalid') {
                                this.props.openNotification(
                                    T(
                                        'host_internal_order_lot_null_or_quantity_less_than_1',
                                    ),
                                    'danger',
                                );
                            } else if (res.status === 'sku_invalid') {
                                this.props.openNotification(
                                    T('host_internal_order_sku_or_kit_null'),
                                    'danger',
                                );
                            } else if (res.status === 'sku_empty') {
                                this.props.openNotification(
                                    T('host_internal_order_at_least_one_sku'),
                                    'danger',
                                );
                            } else if (res.status === 'lot_not_found') {
                                this.props.openNotification(
                                    T('host_internal_order_lot_not_found'),
                                    'danger',
                                );
                            } else if (
                                res.status === 'internal_order_status_invalid'
                            ) {
                                this.props.openNotification(
                                    T('host_internal_order_invali_status'),
                                    'danger',
                                );
                            }
                        }
                    }
                });
        }
    };

    getCurrentScId = (scId, scObj) => {
        let currentSCId = '';
        if (scId) {
            currentSCId = scId;
        } else {
            if (typeof scObj === 'string') {
                currentSCId = scObj;
            } else {
                currentSCId = scObj.id;
            }
        }
        return currentSCId;
    };

    goBack = () => {
        if (
            this.props.history.location.state &&
            (this.props.history.location.state.orderType === 0 ||
                this.props.history.location.state.orderType === 1)
        ) {
            let orderType = this.props.history.location.state.orderType;
            this.props.history.push('/internalTransferOrderList', {orderType});
        } else {
            this.props.history.push('/internalTransferOrderList');
        }
    };

    handleSelectTelChange = (item) => {
        this.setState({
            telephone: item.name,
        });
    };

    deletSkuLotModal = (deleteId) => {
        let {internalSkuItemModels} = this.state;
        if (internalSkuItemModels.length > 1) {
            internalSkuItemModels.splice(
                internalSkuItemModels.findIndex((item) => item.id === deleteId),
                1,
            );

            this.setState({
                internalSkuItemModels: internalSkuItemModels,
            });
        } else {
            this.props.openNotification(T('host_internal_order_need_one_sku'));
        }
    };
    copyToClipBoard = () => {
        const {consignee, telephone, currentAddress} = this.state;
        // let copytext = consignee + '\n'+ telephone + '\n'+ currentAddress;
        if (!this.state.transferToSupplyCenterId) {
            this.props.openNotification(
                T('host_internal_order_transfer_to_not_null'),
                'danger',
            );
        } else {
            copy(
                `${currentAddress && currentAddress} ${
                    consignee && consignee
                } (${telephone && telephone})`,
            );
            this.props.openNotification(
                T('notification_copy_success'),
                'success',
            );
        }
    };

    render() {
        const {
            SClist,
            SCToList,
            consigneeList,
            consignee,
            telephone,
            currentAddress,
            trackingNumber,
            selectedValue,
            skuList,
            lotList,
            internalOrdercomments,
            internalSkuItemModels,
            orderNumber,
        } = this.state;
        const {supplyCenterlist, localData} = this.props;
        const isSave = false;
        let lang = loadLanguage();

        return (
            <div className="transfer-order-save">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={11}>
                            <span>{T('internal_transfer_order')}</span>
                        </Grid>
                    </Grid>
                </Header>

                <div className="current-supply-center-content">
                    <div className="section-title">
                        {T('host_internal_order_current_sp')}
                    </div>
                    <section className="content-box">
                        <Grid container spacing={0} justify={'center'}>
                            <Grid item xs={12}>
                                {supplyCenterlist &&
                                supplyCenterlist.length > 0 ? (
                                    <SelectInput
                                        title={'supplyCenterId'}
                                        placeholder={
                                            'host_abnormal_selece_scName'
                                        }
                                        list={SClist}
                                        value={this.state.supplyCenterId}
                                        inputValid={this.handleChange}
                                        type="text"
                                        focusInput={this.focusInput}
                                    />
                                ) : null}
                            </Grid>
                            {this.getParams().orderId ? (
                                <Grid
                                    item
                                    xs={12}
                                    className="order_number_container">
                                    <Grid className="order-number-label">
                                        {T('order_number')}
                                    </Grid>
                                    <Grid className="order-number-value">
                                        {orderNumber}
                                    </Grid>
                                </Grid>
                            ) : null}
                        </Grid>
                    </section>
                </div>
                <div className="content">
                    <div className="section-title">
                        {T('host_internal_order_transfer_to')}
                        {localData.roleType === USER_ROLE.HOST ? (
                            <BasicButton
                                className="copy-red"
                                onClickOfSingleTap={this.copyToClipBoard}
                                isStopPropagation={true}>
                                {T('copyall_btn_label')}
                            </BasicButton>
                        ) : null}
                    </div>
                    <section className="content-box abnormal-record-basicselect">
                        <Grid
                            container
                            spacing={0}
                            justify={'center'}
                            className="transfer-to-container">
                            <Grid item xs={12}>
                                {
                                    <SelectInput
                                        title={'transferToSupplyCenterId'}
                                        placeholder={
                                            'host_abnormal_selece_scName'
                                        }
                                        list={SCToList}
                                        value={
                                            this.state.transferToSupplyCenterId
                                        }
                                        inputValid={
                                            this.handleTransferToScChange
                                        }
                                        type="text"
                                        focusInput={this.focusTransferToInput}
                                    />
                                }
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                className="transfer-to-consignee">
                                <SelectInput
                                    title={'consignee'}
                                    placeholder={T(
                                        'host_please_select_consignee',
                                    )}
                                    list={consigneeList}
                                    value={consignee}
                                    inputValid={this.handleSelectChange}
                                    type="text"
                                    focusInput={this.focusReceiverInput}
                                />
                            </Grid>
                            {/* <Grid item xs={12} className="transfer-to-supply-center">
							<label className="input-title">{T('consignee')}</label>
							<Select
								className="select"
								value={consignee}
								placeholder={T('host_please_select_consignee')}
								data={consigneeList}
								displayKey="name"
								valueKey="id"
								onChange={this.handleSelectChange}
								options={{icon: {show: true, color: '#E82D38'}}}
                        	/>
						</Grid> */}
                            <Grid
                                item
                                xs={12}
                                className="transfer-to-supply-center">
                                <BasicOnInput
                                    title={'telephone'}
                                    placeholder=""
                                    defalutValue={telephone}
                                    inputValid={this.handleOnTelInput}
                                    isSearchChange={true}
                                    type="text"
                                    value={telephone}
                                />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                className="shippment-address-container">
                                <BasicTextArea
                                    title={'shippingAddress'}
                                    placeholder=""
                                    defalutValue={currentAddress}
                                    inputValid={this.handleOnInput}
                                    isSearchChange={true}
                                    type="text"
                                    value={currentAddress}
                                />
                                {/* <div className="shipping-address-title">
								{T('shippingAddress')}
							</div>
							<p className="shipping-address-constent">
								{currentAddress}
							</p> */}
                            </Grid>
                            {localData.roleType === USER_ROLE.HOST ? (
                                <Grid
                                    className="delivery-method-container"
                                    container
                                    spacing={0}
                                    justify={'space-evenly'}>
                                    <Grid
                                        className="delivery-method-grid"
                                        item
                                        xs={3}>
                                        <span className="delivery-method-label">
                                            {T('order_delivery_method')}
                                        </span>
                                    </Grid>
                                    <Grid
                                        className="delivery-method-radio"
                                        item
                                        xs={9}>
                                        <Checkbox
                                            checked={selectedValue === 1}
                                            onChange={this.handleChangeRadio}
                                            value={1}
                                            className={
                                                selectedValue === 1
                                                    ? 'radio-button checked'
                                                    : 'radio-button'
                                            }
                                        />{' '}
                                        {T('host_internal_order_self_pick_up')}
                                        <Checkbox
                                            checked={selectedValue === 2}
                                            onChange={this.handleChangeRadio}
                                            value={2}
                                            className={
                                                selectedValue === 2
                                                    ? 'radio-button checked'
                                                    : 'radio-button'
                                            }
                                        />{' '}
                                        {T('order_self_express')}
                                    </Grid>
                                </Grid>
                            ) : null}
                            {localData.roleType === USER_ROLE.HOST ? (
                                <Grid
                                    item
                                    xs={12}
                                    className="tracking-number-container">
                                    <BasicInput
                                        title={
                                            'shippment_details_shipment_number'
                                        }
                                        placeholder=""
                                        inputValid={
                                            this.handleTrackingNumberInput
                                        }
                                        isSearchChange={true}
                                        type="text"
                                        value={trackingNumber}
                                    />
                                </Grid>
                            ) : null}
                            <Grid
                                item
                                xs={12}
                                className="transfer-remark-container">
                                <BasicTextArea
                                    type="text"
                                    title={'backup_comments'}
                                    inputValid={this.handleTextArea}
                                    defalutValue={internalOrdercomments}
                                    value={internalOrdercomments}
                                />
                            </Grid>
                        </Grid>
                    </section>
                </div>

                <div className="current-supply-center-content">
                    {internalSkuItemModels.map((comps, index) => (
                        <section className="content-box">
                            <Grid
                                container
                                spacing={0}
                                justify={'center'}
                                className="sku-container">
                                <Grid item xs={12} className="sku-display">
                                    <SelectInput
                                        title={'skuNum'}
                                        placeholder={'backup_please_input_sku'}
                                        list={skuList}
                                        value={comps.kitDisplay}
                                        currentKey={comps.id}
                                        name="sku"
                                        inventoryId="inventoryId"
                                        kit="kit"
                                        inputValid={this.handleSearchSkuChange}
                                        type="text"
                                        focusInput={this.focusSkuNumInput}
                                    />
                                    <Anchor
                                        className="delete-sku-lot-a"
                                        onClickOfSingleTap={() =>
                                            this.deletSkuLotModal(comps.id)
                                        }>
                                        <span className="sku-lot-delete-btn">
                                            {T('backup_delete_button')}
                                        </span>
                                    </Anchor>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} justify={'center'}>
                                <Grid item xs={12}>
                                    <SelectInput
                                        title={'LotNum'}
                                        placeholder={'host_abnormal_selece_lot'}
                                        list={lotList}
                                        value={comps.lot}
                                        name="lot"
                                        currentKey={comps.id}
                                        inputValid={this.handleLotChange}
                                        type="text"
                                        focusInput={() =>
                                            this.focusLotNumInput(comps.id)
                                        }
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} justify={'center'}>
                                <Grid
                                    item
                                    xs={12}
                                    className="transfer-order-save-look">
                                    <Grid className="transfer-order-save-look-title">
                                        {T('storeCondition')}
                                    </Grid>
                                    <Grid
                                        item
                                        className="transfer-order-save-look-content">
                                        {comps.storeCondition}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} justify={'center'}>
                                <Grid
                                    item
                                    xs={12}
                                    className="transfer-order-save-look">
                                    <Grid className="transfer-order-save-look-title">
                                        {T('fone_order_shipping_condition')}
                                    </Grid>
                                    <Grid
                                        item
                                        className="transfer-order-save-look-content">
                                        {comps.shippingCondition}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={0} justify={'center'}>
                                <Grid
                                    item
                                    xs={12}
                                    className="transfer-order-save-look">
                                    <Grid className="transfer-order-save-look-title">
                                        {T('specifications')}
                                    </Grid>
                                    <Grid
                                        item
                                        className="transfer-order-save-look-content">
                                        {comps.specifications}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} className="quantitys-infor-box">
                                <div className="quantitys-infor">
                                    <span className="quantitys-title">
                                        <span className="input-title">
                                            {T('host_abnormal_amount')}
                                        </span>
                                    </span>
                                </div>
                                <div className="quantitys-value">
                                    <Counter
                                        inputValid={this.changeNum}
                                        name="quantity"
                                        currentSkuIndex={comps.id}
                                        defalutValue={
                                            comps.quantity > 1
                                                ? comps.quantity
                                                : 1
                                        }
                                        options={{
                                            value: comps.quantity,
                                            min: 1,
                                        }}></Counter>
                                </div>
                            </Grid>
                        </section>
                    ))}
                </div>

                <Grid className="add-sku-container">
                    <BasicButton
                        className="add-sku-area"
                        onClickOfSingleTap={this.addInternalOrderSkuModal}>
                        <label className="plus-label">+</label>
                        {T('backup_sku')}
                    </BasicButton>
                </Grid>
                <Grid
                    className="confirm-select"
                    container
                    spacing={0}
                    justify={'center'}>
                    <Grid item xs={5}>
                        <BasicButton
                            className={util.getClassName({
                                'btn-width': true && lang !== 'EN',
                                'en-btn-width': true && lang === 'EN',
                            })}
                            type="primary"
                            disabled={!isSave ? false : true}
                            onClickOfSingleTap={this.submitSave}>
                            <span>{T('host_please_confirm_transfer')}</span>
                        </BasicButton>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData} = state;
    return {
        supplyCenterlist: host.supplyCenterlist,
        skuVagueSearchData: host.skuVagueSearchData,
        supplyCenterAlllist: host.supplyCenterAlllist,
        localData: localData,
    };
};

const mapDispatchToProps = {
    openNotification,
    getSupplyCenterList,
    getInternalOrderScHostAddress,
    applyInternalOrderTransfer,
    getSkuKitListOfInternalOrder,
    getLotQuantityOfInternalOrder,
    getAllSCList,
    getInternalOrderDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTransferOrder);
